<script>
    
    import moment from 'moment'
    import { toast } from 'bulma-toast'
    import { userStore, accountsStore, modalStore } from '../stores'
    import AccountsService from '../$services/accounts.service'

    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import InputNumber from '../$components/input.number.svelte'

    let data = {
        autoRenew: false,
        cycleType: 'monthDays',
        monthDays: `14, ${ moment().get('month') != 1? '29' : '27' }`
    }

    let loading = false

    async function createAccount() {

        data.userId = $userStore._id

        loading = true
        const resp = await AccountsService.createAccount(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountsStore.append(resp.data)
        modalStore.close()

        toast({message: 'Cuenta creada', type: 'is-success'})
    }
</script>

<Form on:submit={ createAccount } { loading } >
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.limit} label="Limite" placeholder="Limite del crédito" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" {loading} />
        </div>
    </div>
</Form>